<template>
  <div v-if="loadingVisible" class="loading-overlay">
    <div class="d-flex flex-column align-items-center justify-content-center h-100">
      <div class="spinner-border text-light" role="status" style="width: 3rem; height: 3rem;"></div>
      <p class="mt-3 text-light font-weight-bold">{{ loadingText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalLoading',
  inject: ['getLoadingVisible', 'getLoadingText'],
  computed: {
    loadingVisible() {
      return this.getLoadingVisible();
    },
    loadingText() {
      return this.getLoadingText();
    }
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 마스크 배경 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-text {
  color: white;
  margin-top: 1rem;
  font-size: 1.2rem;
}
</style>